import React from 'react';
import classNames from 'classnames';

type BasicPageTitleProps = {
  children?: React.ReactNode;
  title: string;
};

export default function BasicPageTitle({
  children = null,
  title,
}: BasicPageTitleProps) {
  const defaultContent = (
    <div className={classNames('flex items-center', { 'pb-4': !children })}>
      <div className="text-2xl font-semibold">{title}</div>
    </div>
  );

  if (children) {
    return (
      <div className="flex w-full items-center justify-between pb-4">
        {defaultContent}
        {children}
      </div>
    );
  }

  return defaultContent;
}
